import Buttons from 'components/molecules/buttons';
import { Form } from 'components/organisms';
import {
  artistInitialValues,
  ArtistTabs,
} from 'components/organisms/forms/artist/ArtistForm';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDeleteArtist, useGetArtist } from 'services/artists';
import { getLastPathname } from 'utils/navbar/getParentPathname';
import { onErrorShowToast } from 'utils/service/errorHandler';

const Artist = () => {
  const artistId = useParamId('artist');
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const getArtist = useGetArtist(artistId);
  const deleteArtist = useDeleteArtist(artistId);

  const onRemoveArtist = async () => {
    await deleteArtist.mutateAsync(undefined, {
      onError: error => onErrorShowToast(error),
      onSuccess: () => navigate('/artist'),
    });
  };

  return (
    <Form.Artist
      i18nextPrefix='artist'
      initialValues={
        getArtist.data
          ? middleware.artist.queryToForm(getArtist.data)
          : artistInitialValues
      }
      onSubmit={() => {}}
      tittle={getArtist.data?.nickname ?? '...'}
      status={{ displayMode: true, isLoading: getArtist.isLoading }}
      disableTabs={[ArtistTabs.bio]}
      topbarContent={
        <Buttons.IndividualPage
          onClick={() =>
            navigate(`/artist/edit/${artistId}/${getLastPathname(pathname)}`, {
              replace: true,
            })
          }
          name={getArtist.data?.nickname}
          onRemove={onRemoveArtist}
        />
      }
    />
  );
};

export default Artist;
